<template>
  <Breadcrumbs title="" main="Pages" />
  <div class="container-fluid">
    <div class="faq-wrap">
      <div class="row">
        <div class="col-xl-5 box-col-7">
          <div class="card bg-primary">
            <div class="card-body">
              <p>&nbsp;</p>
              <div class="media faq-widgets">
                <div class="media-body">
                  <h2>{{this.currentLanguage ==='en'?"About us":"เกี่ยวกับเรา"}}</h2>
                  <p>
                    SPORTACTION.PHOTOS
                  </p>
                  <p>A freelance photographer who sells photographs of celebrities to the media,</p>
                  <p>especially one who pursues celebrities and attempts to obtain candid photograph</p>
                </div>
                <vue-feather type="award"></vue-feather>
              </div>
            </div>
          </div>
        </div>
     
        <div style="padding-top: 10px;" class="col-xl-7 col-sm-12 box-col-12">
          <div class="card bg-primary">
            <div class="card-body">
              <p>&nbsp;</p>
              <div class="media faq-widgets">
                <div class="media-body">
                  <h2>{{this.currentLanguage ==='en'?"Contact us":"ติดต่อเรา"}}</h2>
                  <p>8/65 ซ.01 กาญจนาภิเษก 39 ดอกไม้ ประเวศ กทม</p>
                  <p>LINEID: @sportaction</p>
                  <p>page: https://www.facebook.com/sportactionteam</p>
                </div>
                <vue-feather type="mail"></vue-feather>
              </div>
            </div>
          </div>
        </div>
        <p>&nbsp;</p>
        <!-- <div class="col-xl-7 box-col-7">
          <div class="card bg-primary">
            <div class="card-body">
              <p>&nbsp;</p>
              <div class="media faq-widgets">
                
                <div class="media-body">
                  <h2>{{this.currentLanguage ==='en'?"Mission":"พันธกิจ"}}</h2>
                  <h5>
                    ร่วมพัฒนาไปด้วยกัน #พัฒนาคน #พัฒนางาน #พัฒนาระบบ
                    สู่มาตรฐานเดียวกัน
                  </h5>
                  <b style="text-align: right">We will make perfect for all</b>
                </div>
                <vue-feather type="hash"></vue-feather>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="col-xl-5 box-col-5">
          <div class="card">
            <div class="card-body">
              <div class="media faq-widgets">
                <img
                  style="align-items: center; width: 440px"
                  src="../../assets/images/logo/logo.png"
                />
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>

import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'

export default {

  setup() {
    useHead({
      title: computed(() => `SPORTACTION.PHOTOS`),
      meta: [
        {
          name: `description`,
          content: computed(() => `SPORTACTION.PHOTOS`),
        },
        {
          name: `keywords`,
          content: computed(() => `SPORTACTION.PHOTOS`),
        }
        ],
     
    })
  },
  data() {
    return {
      currentLanguage: 'en'   
    };
  },
  async created(){
    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }
  },


};
</script>